<template>
  <div class="c-latest-spotlight">
    <sc-text tag="h3" class="c-latest-spotlight__headline" :field="fields.heading" />
    <sc-link
      v-if="fields && fields.link"
      :field="fields.link"
      class="c-latest-spotlight__link"
      :class="fields.link.value.class"
    />
    <div v-if="description" class="c-latest-spotlight__desc">{{ description }}</div>
    <a href="https://learn.cisecurity.org/ei-isac-registration" class="c-cta--tertiary">
      Join EI-ISAC to subscribe to our emails
    </a>
  </div>
</template>

<script>
import { Link, Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Latest-Spotlight',
  components: {
    ScLink: Link,
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    description() {
      var description = this.fields?.description.value;

      // Remove HTML tags
      var descriptionClean = description.replace(/<[^>]+>/g, '').trim();

      return descriptionClean.length > 0 && descriptionClean.length > 145
        ? descriptionClean.substr(0, 145) + '...'
        : descriptionClean;
    }
  }
};
</script>
<style lang="scss" scoped>
.c-latest-spotlight {
  clear: both;
  border: solid 1px $lite-gray;
  padding: 2rem;

  &__headline {
    font-weight: 500;
  }

  &__link {
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }

  &__desc {
    @include font-styles('Arial', 2rem, 300, normal, 3rem, 0, $gray);
    display: block;
    margin-bottom: 2rem;
  }

  .c-cta--tertiary {
    margin-bottom: 0;
  }
}
</style>
